import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Table } from 'react-bootstrap';
import { FormattedDate, injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { deleterDispatchHelper } from 'actions/DeleterActions';
import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import SimplePrompt from 'components/layout/SimplePrompt';

import List from 'components/List';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';
import AllowedDomainFormModal from 'components/modals/AllowedDomainFormModal';

class AllowedDomains extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showForm: false,
      actualFormData: null,
    };
  }

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
    } = this.props;

    return (
      <Breadcrumb
        crumbs={[{ link: appIntl.urlPrefix + 'account', name: 'Dashboard' }, {
          link: null,
          name: messages.allowed_domains_title,
        }]}
        className="p-t-0"
      />
    );
  };

  handleEditClick = (allowedDomain) => {
    this.setState({ actualFormData: allowedDomain });
    this.showEditForm();
  };

  handleRemoveClick = (e, allowedDomainId) => {
    e.preventDefault();
    e.stopPropagation();

    const { deleteAllowedDomain } = this.props;
    deleteAllowedDomain(allowedDomainId);
  };

  getIcon(value) {
    return value ?
      <i className="fa fa-check" style={{ color: 'green', fontSize: '25px' }} /> :
      <i className="fa fa-times" style={{ color: 'red', fontSize: '25px' }} />;
  }

  showNewForm = () => {
    this.setState({ showNewForm: true });
  };
  showEditForm = () => {
    this.setState({ showEditForm: true });
  };

  closeNewForm = () => {
    this.setState({ showNewForm: false });
  };

  closeEditForm = () => {
    this.setState({ showEditForm: false });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      list,
      location,
      user,
    } = this.props;
    const { showNewForm, showEditForm, actualFormData } = this.state;

    const searchParams = new URLSearchParams(location.search);
    const columns = [
      messages.allowed_domains_domain_name,
      messages.allowed_domains_default_src,
      messages.allowed_domains_script_src,
      messages.allowed_domains_connect_src,
      messages.allowed_domains_style_src,
      messages.allowed_domains_font_src,
      messages.allowed_domains_frame_src,
      messages.created_at,
      messages.actions];
    const tBody = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const allowedDomain = list.data.list[i];
      tBody.push(
        <tr key={i}>
          <td class="v-align-middle">{allowedDomain.domain_name}</td>
          <td class="v-align-middle">{this.getIcon(allowedDomain.default_src)}</td>
          <td class="v-align-middle">{this.getIcon(allowedDomain.script_src)}</td>
          <td class="v-align-middle">{this.getIcon(allowedDomain.connect_src)}</td>
          <td class="v-align-middle">{this.getIcon(allowedDomain.style_src)}</td>
          <td class="v-align-middle">{this.getIcon(allowedDomain.font_src)}</td>
          <td class="v-align-middle">{this.getIcon(allowedDomain.frame_src)}</td>
          <td class="v-align-middle"><FormattedDate value={allowedDomain.cdate} /></td>
          <td class="v-align-middle text-right">
            <Button bsSize="sm" class="btn-rounded" bsStyle="default" style={{marginRight: '5px', marginLeft: '5px'}} onClick={() => this.handleEditClick(allowedDomain)}><i
              class="fa fa-pencil-alt" /> {messages.edit}</Button>
            <SimplePrompt
              onSuccess={e => {
                this.handleRemoveClick(e, allowedDomain.id);
              }}
            />
          </td>
        </tr>,
      );
    }

    const resultTable = list.pending ? (
      <Loader />
    ) : (
      <Table responsive hover>
        <thead>
        <tr>
          {columns.map(column => {
            return (
              <th key={column} class={column === messages.actions ? 'text-right' : ''}>
                {column}
              </th>
            );
          })}
        </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );

    return (
      <DocMeta tags={generateMetaTags(messages.meta.allowedDomains)}>
        <List
          listName="allowedDomains"
          url="/api/alloweddomains.json"
          // urlData={{ filters: { type: 'company', parent } }}
          list={list}
          title={messages.allowed_domains_title}
          iconClass="fa fa-tasks"
          showNew
          newText={messages.add_allowed_domain}
          newAction={this.showNewForm}
          showSearch={false}
          // sortOptions={['domainName,asc', 'domainName,desc']}
          breadcrumb={this.getBreadcrumb()}
        >
          {resultTable}
          <AllowedDomainFormModal id="allowedDomainNewForm" type={'new'} show={showNewForm} close={this.closeNewForm} />
          <AllowedDomainFormModal id="allowedDomainEditForm" type={'edit'} show={showEditForm}
                                  close={this.closeEditForm} allowedDomain={actualFormData} />

        </List>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.allowedDomains,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deleteAllowedDomain: allowedDomainId => {
      deleterDispatchHelper('allowedDomain', '/api/alloweddomains/' + allowedDomainId + '.json', dispatch);
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(AllowedDomains),
  ),
);
